// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import linkDirectionEntity from './entities/link-direction.json';
import linkDirectionMenu from '../pages/link-direction/menu.json';
import linkDirectionFullForm from '../pages/link-direction/forms/full.json';
import linkDirectionContextForm from '../pages/link-direction/forms/context.json';
import linkDirectionMiniForm from '../pages/link-direction/forms/mini.json';
import linkDirectionLookupForm from '../pages/link-direction/forms/lookup.json';
import linkDirectionTableView from '../pages/link-direction/views/table.json';
import linkDirectionCardsView from '../pages/link-direction/views/cards.json';
import linkDirectionDashboardView from '../pages/link-direction/views/dashboard.json';

/** Тип запису «Напрям зв’язку» зі сторінками пакета: меню, форми та подання з pages/link-direction/. */
export const linkDirectionDefinition: IRecordTypeDefinition = {
  ...linkDirectionEntity,
  views: assembleViewSet({
      table: linkDirectionTableView,
      cards: linkDirectionCardsView,
      dashboard: linkDirectionDashboardView,
  }),
  form: linkDirectionFullForm,
  forms: { full: linkDirectionFullForm, context: linkDirectionContextForm, mini: linkDirectionMiniForm, lookup: linkDirectionLookupForm },
  menu: linkDirectionMenu,
} as IRecordTypeDefinition;
